import React from 'react';

const NotFound: React.FC = () => (
  <div style={{ textAlign: 'center', padding: 80, fontSize: 24, color: '#888' }}>
    404 - 页面不存在
  </div>
);

export default NotFound; 